'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    IoTStatusTableController.$inject = ['$interval', '$q', '$state', 'analyticsService', 'appConfig', 'iotService'];
    angular.module('app.admin').component('iotStatusTable', {
        template: '<table class="table table-condensed table-striped table-hover" translate-namespace="admin.iot-status"><colgroup><col style="width:30px;"><col><col><col style="width:150px;"><col style="width:80px;"><col style="width:120px;"></colgroup><thead><tr><th></th><th><a ng-click="$ctrl.toggleOrderBy(\'name\')" translate>.Gateway</a> <span ng-show="$ctrl.orderBy.column === \'name\'"><i class="fa fa-sort-asc" ng-show="$ctrl.orderBy.reverse" aria-hidden="true"></i> <i class="fa fa-sort-desc" ng-show="!$ctrl.orderBy.reverse" aria-hidden="true"></i></span></th><th></th><th><a ng-click="$ctrl.toggleOrderBy(\'alerts\')" translate>.Alerts (today)</a> <span ng-show="$ctrl.orderBy.column === \'alerts\'"><i class="fa fa-sort-asc" ng-show="$ctrl.orderBy.reverse" aria-hidden="true"></i> <i class="fa fa-sort-desc" ng-show="!$ctrl.orderBy.reverse" aria-hidden="true"></i></span></th><th><a ng-click="$ctrl.toggleOrderBy(\'online\')" translate>.Status</a> <span ng-show="$ctrl.orderBy.column === \'online\'"><i class="fa fa-sort-asc" ng-show="$ctrl.orderBy.reverse" aria-hidden="true"></i> <i class="fa fa-sort-desc" ng-show="!$ctrl.orderBy.reverse" aria-hidden="true"></i></span></th><th class="text-right"><a ng-click="$ctrl.toggleOrderBy(\'since\')" translate>.Since</a> <span ng-show="$ctrl.orderBy.column === \'since\'"><i class="fa fa-sort-asc" ng-show="$ctrl.orderBy.reverse" aria-hidden="true"></i> <i class="fa fa-sort-desc" ng-show="!$ctrl.orderBy.reverse" aria-hidden="true"></i></span></th></tr></thead><tbody><tr ng-repeat-start="gateway in $ctrl.gateways | orderBy: $ctrl.orderBy.column : $ctrl.orderBy.reverse" ng-click="$ctrl.onGatewayToggle(gateway)"><td><i class="fa fa-plus-circle" aria-hidden="true" ng-if="!gateway.expanded"></i> <i class="fa fa-minus-circle" aria-hidden="true" ng-if="gateway.expanded"></i></td><td>{{gateway.name}}</td><td>{{gateway.devicesStatus[\'true\'] || 0}} / {{gateway.devicesStatus[\'true\'] + gateway.devicesStatus[\'false\']}}</td><td><span ng-if="gateway.alerts"><i class="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i> {{gateway.alerts}}</span></td><td translate-namespace="admin.gateway"><span ng-if="gateway.online" class="label label-success" translate>.Online</span> <span ng-if="!gateway.online" class="label label-danger" translate>.Offline</span></td><td class="text-right">{{gateway.since | date: \'dd/MM/yy, HH:mm\'}}</td></tr><tr ng-repeat-end ng-if="gateway.expanded" ng-repeat="device in gateway.devices"><td>&nbsp;</td><td colspan="2"><a ui-sref="device-status({id:device.id})">{{device.name}}</a></td><td><span ng-if="$ctrl.deviceAlertsCount[device.id]"><i class="fa fa-exclamation-triangle text-warning" aria-hidden="true"></i> {{$ctrl.deviceAlertsCount[device.id]}}</span></td><td translate-namespace="admin.device"><span ng-if="device.online" class="label label-success" translate>.Online</span> <span ng-if="!device.online" class="label label-danger" translate>.Offline</span></td><td class="text-right">{{device.since | date: \'dd/MM/yy, HH:mm\'}}</td></tr></tbody></table>',
        controller: IoTStatusTableController,
        controllerAs: '$ctrl'
    });

    function IoTStatusTableController($interval, $q, $state, analyticsService, appConfig, iotService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        /**
         * 
         */
        $ctrl.$onInit = function () {

            $ctrl.orderBy = { column: 'name', reverse: false };

            update();
            $ctrl.updater = $interval(update, 60000, 100);
        };

        /**
         * 
         */
        function update() {
            var to = moment(),
                from = to.clone().startOf('day');

            $q.all({
                gateways: iotService.getGateways(true),
                alertsCount: analyticsService.getAlertsCount(from, to)
            }).then(function (r) {
                $ctrl.gateways = r.gateways;
                $ctrl.devices = _.flatMap(r.gateways, 'devices');

                $ctrl.gatewayAlertsCount = _(r.alertsCount).groupBy('gateway_id').mapValues(function (o) {
                    return _.sumBy(o, 'count');
                }).value();

                $ctrl.deviceAlertsCount = _(r.alertsCount).groupBy('device_id').mapValues(function (o) {
                    return _.sumBy(o, 'count');
                }).value();

                _.each($ctrl.gateways, function (g) {
                    g.devicesStatus = _.countBy(g.devices, 'online');
                    g.alerts = $ctrl.gatewayAlertsCount[g.id];
                });
            }).catch(function (error) {

                if (error.status === 401) {
                    $state.go('login');
                }

                console.error('Oops, something went wrong!', error);
            });
        }

        /**
         * 
         */
        $ctrl.$onDestroy = function () {
            $interval.cancel($ctrl.updater);
        };

        /**
         * 
         * @param {*} gateway 
         */
        $ctrl.onGatewayToggle = function (gateway) {
            gateway.expanded = !gateway.expanded;
        };

        /**
         * 
         * @param {*} column 
         */
        $ctrl.toggleOrderBy = function (column) {
            if ($ctrl.orderBy.column === column) {
                $ctrl.orderBy.reverse = !$ctrl.orderBy.reverse;
            } else {
                $ctrl.orderBy.column = column;
                $ctrl.orderBy.reverse = false;
            }
        };
    }
})();